module.exports = __webpack_public_path__ + "img/oculus.97eee5b9.svg";